import {alias, createModelSchema, list, reference} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {WorkerKey} from "@/modules/redactor/models/worker/WorkerKey";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class WorkerTeam extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getWorkerTeam(uid));
        });
    }

    constructor(name = null) {
        super();

        this._name = name;
        this._workers = [];
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get workers() {
        return this._workers;
    }

    set workers(value) {
        this._workers = value;
    }

    valid() {

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.workers.length <= 0 || this.workers.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.workers.length <= 0;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorkerTeam());
        } else if (target instanceof WorkerTeam) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorkerTeam, {
    _name: alias("name", Schema.primitive()),
    _workers: alias("workers", list(WorkerKey.schema()))
});